/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "eu-central-1",
    "aws_cloud_logic_custom": [
        {
            "name": "SUMS",
            "endpoint": "https://tmbu592cb1.execute-api.eu-central-1.amazonaws.com/prodvpc",
            "region": "eu-central-1"
        }
    ],
    "aws_cognito_identity_pool_id": "eu-central-1:4b6e2c29-1ca8-4064-aa98-99cfa774926d",
    "aws_cognito_region": "eu-central-1",
    "aws_user_pools_id": "eu-central-1_MwfXFrub7",
    "aws_user_pools_web_client_id": "4436b0163u5v21r9o7jtl4p1ff",
    "oauth": {},
    "aws_cognito_username_attributes": [
        "EMAIL"
    ],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_dynamodb_all_tables_region": "eu-central-1",
    "aws_dynamodb_table_schemas": [
        {
            "tableName": "Sums_Main_Table",
            "region": "eu-central-1"
        }
    ]
};


export default awsmobile;
